import React from 'react';
import { CONTAINER_TEST_ID, UPSELL_TEST_ID, VARIATION_CONTAINER_TEST_ID, PRICE_CONTAINER_TEST_ID } from './constants';
import { RowContainer, PriceContainer, StyledPrice, StyledRadio, StyledSubtext, StyledTag, StyledTitle, Upsell, VariationContainer } from './styled';
// CW-1078 @TODO replace with truncationLength prop once it is available from chegg-ui component
var getTruncationType = function getTruncationType(tagText) {
  return tagText.length > 24 ? 'end' : 'none';
};
export var ProductVariationRow = function ProductVariationRow(_ref) {
  var isSelected = _ref.isSelected,
    onClick = _ref.onClick,
    price = _ref.price,
    priceSubtext = _ref.priceSubtext,
    tagText = _ref.tagText,
    title = _ref.title,
    upsellText = _ref.upsellText,
    id = _ref.id,
    subscriptionRecurrence = _ref.subscriptionRecurrence,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(RowContainer, {
    "data-test": CONTAINER_TEST_ID,
    onClick: onClick,
    size: size
  }, upsellText && /*#__PURE__*/React.createElement(Upsell, {
    "data-test": UPSELL_TEST_ID,
    id: "".concat(id, "-upsell")
  }, upsellText), /*#__PURE__*/React.createElement(VariationContainer, {
    "data-test": VARIATION_CONTAINER_TEST_ID,
    isSelected: isSelected
  }, /*#__PURE__*/React.createElement(StyledRadio, {
    checked: isSelected,
    inputId: "".concat(id, "-input"),
    size: "large",
    "aria-labelledby": "".concat(id, "-upsell ").concat(id, "-input ").concat(id, "-price-container")
  }, /*#__PURE__*/React.createElement(StyledTitle, null, title), tagText && /*#__PURE__*/React.createElement(StyledTag, {
    truncationType: getTruncationType(tagText)
  }, tagText)), /*#__PURE__*/React.createElement(PriceContainer, {
    "data-test": PRICE_CONTAINER_TEST_ID,
    id: "".concat(id, "-price-container")
  }, /*#__PURE__*/React.createElement(StyledPrice, null, "".concat(price).concat(subscriptionRecurrence)), priceSubtext && /*#__PURE__*/React.createElement(StyledSubtext, null, priceSubtext))));
};
export default ProductVariationRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ProductVariationRow/ProductVariationRow.js
// module id = 4054
// module chunks = 11